export default __webpack_public_path__ + "static/37-5e3978d4e7d8178a85ee2f043e62b6bf.png";